__turbopack_context__.v({
  "sideImage": "diTcna_sideImage",
  "sideText": "diTcna_sideText",
  "sideTextImageLeft": "diTcna_sideTextImageLeft",
  "sideTextImageRight": "diTcna_sideTextImageRight",
  "sideWrapper": "diTcna_sideWrapper",
  "sideWrapperImageLeft": "diTcna_sideWrapperImageLeft",
  "sideWrapperImageRight": "diTcna_sideWrapperImageRight",
});
